import agulles from "./agulles";
import regulacio from "./regulacio";
import regulacio_point from "./regulacio_point";
import limitsparc from "./limitsparc";
import limitsparc_point from "./limitsparc_point";
import caminsPNMM from "./caminsPNMM";
import fitxes_foer from "./fitxes_foer";
import senyal_112 from "./senyal_112";
import boixar from "./boixar";
import tanques_vehicle from "./tanques_vehicle";
import aparcaments_point from "./aparcaments_point";
import aparcaments from "./aparcaments";
import areesdescans from "./areesdescans";
import Font_B from "./Font_B";
import Font_C_D from "./Font_C_D";
import Font_CP from "./Font_CP";
import Font_DGT from "./Font_DGT";
import Font_M from "./Font_M";
import Font_R from "./Font_R";
import Font_R_X from "./Font_R_X";
import Ermites from "./Ermites";
import Capella from "./Capella";
import dea from "./dea";
import Coves from "./Coves";
import refugis from "./refugis";
import ZonaAcampada from "./ZonaAcampada";
import PuntsInteres from "./PuntsInteres";
import GR_PR_PNMM from "./GR_PR_PNMM";



export default {
    "agulles-point": {"type": "geojson","data": agulles, "generateId": true},
    "regulacio-json": {"type": "geojson","data": regulacio, "generateId": true},
    "regulacio-point": {"type": "geojson","data": regulacio_point, "generateId": true},
    "limits-json": {"type": "geojson","data": limitsparc, "generateId": true},
    "limits-point": {"type": "geojson","data": limitsparc_point, "generateId": true},
    "camins-json": {"type": "geojson","data": caminsPNMM, "generateId": true},
    "foer-point": {"type": "geojson","data": fitxes_foer, "generateId": true},
    "112-point": {"type": "geojson","data": senyal_112, "generateId": true},
    "boixar-point": {"type": "geojson","data": boixar, "generateId": true},
    "tanques_vehicle-point": {"type": "geojson","data": tanques_vehicle, "generateId": true},
    "aparcaments-point": {"type": "geojson","data": aparcaments_point, "generateId": true},
    "areesdescans-point": {"type": "geojson","data": areesdescans, "generateId": true},
    "aparcaments-json": {"type": "geojson","data": aparcaments, "generateId": true},
    "Font_B": {"type": "geojson","data": Font_B, "generateId": true},
    "Font_C_D": {"type": "geojson","data": Font_C_D, "generateId": true},
    "Font_CP": {"type": "geojson","data": Font_CP, "generateId": true},
    "Font_DGT": {"type": "geojson","data": Font_DGT, "generateId": true},
    "Font_M": {"type": "geojson","data": Font_M, "generateId": true},
    "Font_R": {"type": "geojson","data": Font_R, "generateId": true},
    "Font_R_X": {"type": "geojson","data": Font_R_X, "generateId": true},
    "Ermites": {"type": "geojson","data": Ermites, "generateId": true},
    "Capella": {"type": "geojson","data": Capella, "generateId": true},
    "dea": {"type": "geojson","data": dea, "generateId": true},
    "Coves": {"type": "geojson","data": Coves, "generateId": true},
    "refugis": {"type": "geojson","data": refugis, "generateId": true},
    "ZonaAcampada": {"type": "geojson","data": ZonaAcampada, "generateId": true},
    "PuntsInteres": {"type": "geojson","data": PuntsInteres, "generateId": true},
    "GR_PR_PNMM": {"type": "geojson","data": GR_PR_PNMM, "generateId": true},
        
}
